import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
function insertPositionInOptions(options, insert) {
  return Object.assign({}, options, { insert });
}

class spartaMessageUtility {
  constructor() {
    this._options = {
      listType: 'ordered',
      dismiss: false,
      border: null,
      insert: 'before',
      size: 'large',
      uuid: (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1),
    };

    // set a default type
    this._type = 'info';
    // get current language
    this.language = spartaStoreUtility.getData('lang');
  }

  title(title) {
    this._title = title || '';
    return this;
  }

  message(msg) {
    this._message = msg || '';
    return this;
  }

  type(type) {
    if (type) { this._type = type; }

    return this;
  }

  show(target, localOptions = {}) {
    this._target = target;

    // grab and merge options
    const opts = Object.assign({}, this._options, localOptions);
    this._options = opts;

    // make html template
    const template = this.buildTemplate();

    // insert into dom
    this.attach(template);
    this.addListeners();

    return this;
  }

  buildTemplate() {
    const content = this.formatMessage();
    let style = '';
    let dismiss = '';

    if (this._options.border !== null) {
      style = `style="border-width: ${this._options.border}"`;
    }

    if (this._options.dismiss) {
      if (this.language === 'es-us') {
        dismiss = `<a href="#" class="spartaMessage-close-x"><span aria-hidden="true">×</span><span class="ada-hidden">x: Mensaje de despido</span></a>`;
      } else {
        dismiss = `<a href="#" class="spartaMessage-close-x"><span aria-hidden="true">×</span><span class="ada-hidden">x: Dismiss Message</span></a>`;
      }
    }

    const lang = spartaStoreUtility.getData('jcrLang');

    // get global parameter JCR from Sparta Store
    const spaParams = spartaStoreUtility.getData('spaParams').global[lang];

    // get Object of available icons
    const messageIcons = spaParams.messagingIcons;
    const messageText = spaParams.messageIconText;

    // get icon relevant for this message type
    const icon = messageIcons[this._type];
    const adaText = messageText[this._type];

    // if a title value is included format it
    const title = (this._title !== '') ? `<p class="spartaMessage-title">${this._title}</p>` : '';

    return `<div id="sparta-message-${this._options.uuid}" class="spartaMessage ${this._type} ${this._options.size}" ${style} tabIndex="0">
              <div class="spartaMessage-icon">
                <div class="ada-text-message-icon">${adaText}</div>
                <span class="data-icon">
                  ${icon}
                </span>
              </div>
              <div class="spartaMessage-content">
                ${title}
                ${content}
              </div>
              <div class="spartaMessage-dismiss">
                ${dismiss}
              </div>
            </div>`;
  }

  formatMessage() {
    if (Array.isArray(this._message)) {
      let str = '';
      let startWrap = '';
      let endWrap = '';

      if (this._options.listType === 'ordered' || this._options.listType === 'unordered') {
        startWrap = '<li>';
        endWrap = '</li>';
      }

      if (this._options.listType === 'paragraph') {
        startWrap = '<p>';
        endWrap = '</p>';
      }

      str += (this._options.listType === 'ordered') ? '<ul class="spartaMessage-list">' : '';
      str += (this._options.listType === 'unordered') ? '<ol class="spartaMessage-list">' : '';

      this._message.forEach((item) => {
        str += `${startWrap}${item}${endWrap}`;
      });

      str += (this._options.listType === 'ordered') ? '</ul>' : '';
      str += (this._options.listType === 'unordered') ? '</ol>' : '';

      return str;
    }

    return (this._message !== '') ? `<p class="spartaMessage-text">${this._message}</p>` : '';
  }

  destroy() {
    const { uuid } = this._options;

    if (!uuid) return false;

    const id = `sparta-message-${uuid}`;

    const element = document.getElementById(id);

    if (element) {
      element.parentNode.removeChild(element);
    }

    return false;
  }

  attach(template) {
    const el = this._target instanceof Element ? this._target : document.querySelector(this._target);

    switch (this._options.insert) {
      case 'before':
        el.insertAdjacentHTML('beforebegin', template);
        break;

      case 'after':
        el.insertAdjacentHTML('afterend', template);
        break;

      case 'insideFirst':
      case 'prepend':
        el.insertAdjacentHTML('afterbegin', template);
        break;

      case 'insideLast':
      case 'append':
        el.insertAdjacentHTML('beforeend', template);
        break;

      case 'replace':
      default:
        el.innerHTML = template;
    }
  }

  addListeners() {
    if (this._options.dismiss) {
      const closeIconSelector = `#sparta-message-${this._options.uuid} .spartaMessage-close-x`;
      const closeIcon = document.querySelector(closeIconSelector);
      closeIcon.addEventListener('click', this.close);
    }
  }

  close(evt) {
    evt.preventDefault();

    const element = evt.target.closest('.spartaMessage');

    element.parentNode.removeChild(element);

    return false;
  }

/*
 *=======================
 *  Shorthand Methods for Developers
 *=======================
 */

  showWithProvidedData(target, { type, title, message, options }) {
    this._type = type;
    this._title = title;
    this._message = message;
    this.options = options;

    return this.show(target, options);
  }

  showMessage(target, type, title, message, options = {}) {
    const data = {
      type,
      title,
      message,
      options,
    };

    return this.showWithProvidedData(target, data);
  }

  showBefore(target, options = {}) {
    options.insert = 'before';
    return this.show(target, options);
  }

  showAfter(target, options = {}) {
    options.insert = 'after';
    return this.show(target, options);
  }

  prepend(target, options = {}) {
    options.insert = 'prepend';

    return this.show(target, options);
  }

  showInsideFirst(target, options = {}) {
    return this.prepend(target, options);
  }

  append(target, options = {}) {
    options.insert = 'insideLast';

    return this.show(target, options);
  }

  showInsideLast(target, options = {}) {
    return this.append(target, options);
  }

  showErrorMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'error', title, message, options);
  }

  showErrorMessageBefore(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }

  showErrorMessageAfter(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }

  showErrorMessageInsideFirst(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }

  showErrorMessageInsideLast(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }

  showSuccessMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'success', title, message, options);
  }

  showSuccessMessageBefore(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }

  showSuccessMessageAfter(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }

  showSuccessMessageInsideFirst(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }

  showSuccessMessageInsideLast(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }

  showWarningMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'warning', title, message, options);
  }

  showWarningMessageBefore(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }

  showWarningMessageAfter(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }

  showWarningMessageInsideFirst(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }

  showWarningMessageInsideLast(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }

  showInfoMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'info', title, message, options);
  }

  showInfoMessageBefore(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }

  showInfoMessageAfter(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }

  showInfoMessageInsideFirst(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }

  showInfoMessageInsideLast(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }
}

spartaSingletonUtility('SpartaMessagingUtility', () => spartaMessageUtility);
export default spartaMessageUtility;
